export const saveToContacts = ({ name, position, email, phone, company, location, socialMedia }) => {
    // vCard content with proper formatting
    const vCardData = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `FN:${name}`,
      `N:${name};;;`,
      `TITLE:${position}`,
      company ? `ORG:${company}` : '',
      `EMAIL;type=INTERNET;type=WORK:${email}`,
      phone ? `TEL;type=CELL:${phone}` : '',
      location ? `ADR;type=WORK:;;${location.city};${location.country}` : '',
      socialMedia?.linkedin ? `URL;type=WORK:${socialMedia.linkedin}` : '',
      'END:VCARD'
    ].filter(Boolean).join('\n');
  
    // Data URI that will trigger the native "Add to Contacts" UI
    const encodedData = encodeURIComponent(vCardData);
    const dataUri = `data:text/vcard;charset=utf-8,${encodedData}`;
  
    // On mobile devices, this will typically trigger the native "Add to Contacts" UI
    window.location.href = dataUri;
  
    return true;
};
  